/**
 * MessagesLayout - Responsive 2-column layout for threaded chat
 */

import React from 'react';
import { useMessages } from './MessagesContext';
import ConversationList from './ConversationList';
import ChatThread from './ChatThread';

export default function MessagesLayout() {
  const { activeThreadId, threads, loading, userId } = useMessages();

  console.log('MessagesLayout render:', { 
    activeThreadId, 
    threadCount: threads?.length, 
    loading,
    userId,
    hasContext: !!useMessages()
  });

  const activeThread = threads?.find((t) => t.id === activeThreadId);

  return (
    <div className="grid grid-cols-12 gap-3 h-full">
      {/* Left: Conversation List */}
      <ConversationList />

      {/* Right: Chat Thread or Empty State */}
      <div className="col-span-8 md:col-span-8 lg:col-span-9 xl:col-span-9 flex flex-col bg-white/10 backdrop-blur-xl border border-white/15 rounded-2xl overflow-hidden">
        {activeThread ? (
          <ChatThread thread={activeThread} />
        ) : (
          <div className="flex flex-col items-center justify-center h-full text-center p-8">
            <div className="w-20 h-20 rounded-full bg-white/10 border border-white/20 flex items-center justify-center mb-4">
              <span className="text-4xl">💬</span>
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Select a message</h3>
            <p className="text-sm text-white/60 max-w-sm">
              Choose a conversation from the sidebar to view the message thread and reply.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
